import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { SlickCarouselStyles } from '../../../styles/molecules/slick-carousel.styles';
import { SlickCarouselProps } from './slick-carousel.props';
export const SlickCarouselMolecule = (props: SlickCarouselProps) => {
  const classes = SlickCarouselStyles();
  const defaults = { dotsClass: `${classes.slickDots}` };
  return (
    <Slider {...defaults} {...props.settings}>
      {props.children}
    </Slider>
  );
};
